
import axios from 'axios'
import { businessApiURL, getCountryCode, getLanguageCode, getToken } from '../..'

export async function getCompanyEmployees(page, pageSize, otherParams = {}) {
  try {
    const res = await axios.get(`${businessApiURL}/api/secure/bc/subscribers`, {
      params: {
        languageCode: getCountryCode(),
        countryCode: getLanguageCode(),
        page: page,
        pageSize: pageSize,
        ...otherParams,
      },
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}
